<template>
  <div class="order-confirm-container">
    <div class="order-confirm-header">
      <!-- <button @click="goBack" class="back-button">← 返回</button> -->
      <h2>确认订单</h2>
    </div>

    <div class="order-content">
      <!-- 商品信息 -->
      <div class="section">
        <h3>商品信息</h3>
        <div class="product-summary">
          <div class="product-image">
            <img :src="productDetail.coverImg" alt="商品图片">
          </div>
          <div class="product-details">
            <h4>{{ productDetail.title }}</h4>
            <div class="product-specs-container" v-if="selectedSku.specs">
              <div class="specs-title">规格:</div>
              <div class="specs-content">
                <span v-for="(value, key) in parseSpecs(selectedSku.specs)" :key="key" class="spec-item">
                  <span class="spec-key">{{ key }}:</span>
                  <span class="spec-value">{{ value }}</span>
                </span>
              </div>
            </div>
            <div class="product-specs-container" v-else>
              <div class="specs-title">规格:</div>
              <div class="specs-content">
                <span class="spec-item">
                  <span class="spec-value">默认规格</span>
                </span>
              </div>
            </div>
            <div class="price-quantity">
              <span class="price">¥{{ selectedSku.price || productDetail.price }}</span>
              <span class="quantity">× {{ quantity }}</span>
            </div>
          </div>
        </div>
        <div class="total-amount">
          小计: <span class="amount">¥{{ ((selectedSku.price || productDetail.price) * quantity).toFixed(2) }}</span>
        </div>
      </div>

      <div class="order-content" style="display: flex; gap: 20px;">
        <!-- 收货信息 -->
        <div class="section" style="flex: 2;">
          <h3>收货信息</h3>
          <el-form :model="orderInfo" ref="orderForm" label-width="80px">
            <el-form-item label="收货人" prop="receiver"
                          :rules="{ required: true, message: '请输入收货人姓名', trigger: 'blur' }">
              <el-input v-model="orderInfo.receiver" placeholder="请输入收货人姓名"></el-input>
            </el-form-item>

            <el-form-item label="联系电话" prop="phone"
                          :rules="[{ required: true, message: '请输入联系电话', trigger: 'blur' }, { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }]">
              <el-input v-model="orderInfo.phone" placeholder="请输入联系电话"></el-input>
            </el-form-item>

            <el-form-item label="所在地区" prop="areaCodes"
                          :rules="{ required: true, message: '请选择所在地区', trigger: 'change' }">
              <el-cascader v-model="orderInfo.areaCodes" :options="areaOptions" :props="{ expandTrigger: 'hover' }"
                           @change="handleAreaChange"
                           placeholder="请选择所在地区">
              </el-cascader>
            </el-form-item>

            <el-form-item label="详细地址" prop="detail"
                          :rules="{ required: true, message: '请输入详细地址', trigger: 'blur' }">
              <el-input v-model="orderInfo.detail" placeholder="请输入详细地址"></el-input>
            </el-form-item>
          </el-form>
        </div>

        <!-- 新增：发票信息 -->
        <div class="section" style="flex: 2;">
          <h3>发票信息</h3>
          <el-form :model="invoiceInfo" label-width="80px" :rules="invoiceRules" ref="invoiceForm">
            <el-form-item label="发票类型" prop="invoiceType">
              <el-radio-group v-model="invoiceInfo.invoiceType">
                <el-radio label="personal">个人</el-radio>
                <el-radio label="business">企业</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="发票抬头" prop="invoiceTitle" v-if="invoiceInfo.invoiceType === 'business'">
              <el-input v-model="invoiceInfo.invoiceTitle" placeholder="请输入公司名称"></el-input>
            </el-form-item>
            <el-form-item label="税号" prop="taxNumber" v-if="invoiceInfo.invoiceType === 'business'">
              <el-input v-model="invoiceInfo.taxNumber" placeholder="请输入纳税人识别号（统一社会信用代码）"></el-input>
            </el-form-item>
            <el-form-item label="发票邮箱" prop="invoiceEmail">
              <el-input v-model="invoiceInfo.invoiceEmail" placeholder="请输入接收发票的邮箱"></el-input>
            </el-form-item>
          </el-form>
        </div>

        <!-- 支付方式 -->
        <div class="section" style="flex: 1;">
          <h3>支付方式</h3>
          <div class="payment-methods">
            <div class="payment-options">
              <div :class="['payment-option', { active: paymentMethod === 'wechat' }]"
                   @click="paymentMethod = 'wechat'">
                <div class="payment-icon">
                  <!-- <svg-icon icon-class="wechat" class-name="payment-svg"/> -->
                   <img src="@/assets/wechat.png" alt="微信支付" style="width: 40px; height: 40px;">
                </div>
                <span class="payment-name">微信支付</span>
              </div>

              <div :class="['payment-option', { active: paymentMethod === 'alipay' }]"
                   @click="paymentMethod = 'alipay'">
                <div class="payment-icon">
                  <!-- <i class="alipay-logo">支</i> -->
                  <img src="@/assets/alipay.png" alt="支付宝支付" style="width: 40px; height: 40px;">
                </div>
                <span class="payment-name">支付宝</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部合计 -->
      <div class="section" style="display: flex; justify-content: space-between; align-items: center;">
        <div class="total-price">
          合计: <span class="price">¥{{ ((selectedSku.price || productDetail.price) * quantity).toFixed(2) }}</span>
        </div>
        <el-button type="primary" @click="submitOrder" :loading="isSubmitting">提交订单</el-button>
      </div>
    </div>

    <!-- 微信支付二维码 -->
    <el-dialog :visible.sync="wxDialogVisible" :modal="true" width="500px" :close-on-click-modal="false"
               :before-close="cancelOrder">
      <h1 style="font-size:24px;color:#00B38A;text-align:center;">微信扫码支付</h1>
      <div id="qrcode" class="qrcode-container"></div>
      <p style="text-align:center;font-size:16px;margin-bottom:10px;">请使用微信扫描二维码完成支付</p>
      <p id="closeText" style="color: crimson;text-align:center;font-size:14px;"></p>
    </el-dialog>

    <!-- 支付宝支付二维码 -->
    <el-dialog :visible.sync="aliDialogVisible" :modal="true" width="500px" :close-on-click-modal="false"
               :before-close="cancelOrder">
      <h1 style="font-size:24px;color:#00B38A;text-align:center;">支付宝扫码支付</h1>
      <div id="aliQrcode" class="qrcode-container"></div>
      <p style="text-align:center;font-size:16px;margin-bottom:10px;">请使用支付宝扫描二维码完成支付</p>
    </el-dialog>

  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import provinces from 'china-division/dist/provinces.json'
import cities from 'china-division/dist/cities.json'
import areas from 'china-division/dist/areas.json'


// 转换数据格式以适配 element-ui 的级联选择器
const regionData = provinces.map(province => {
  return {
    value: province.code,
    label: province.name,
    children: cities
      .filter(city => city.provinceCode === province.code)
      .map(city => {
        return {
          value: city.code,
          label: city.name,
          children: areas.filter(area => area.cityCode === city.code).map(area => {
            return {
              value: area.code,
              label: area.name
            }
          })
        }
      })
  }
})

import {request2} from "@/utils/utils";


export default {
  name: 'OrderConfirm',
  data() {
    return {
      productDetail: null,
      selectedSkuId: null,
      quantity: 1,
      orderInfo: {
        receiver: '',
        phone: '',
        province: '',
        city: '',
        area: '',
        areaCodes: [],
        detail: ''
      },
      areaOptions: regionData,
      paymentMethod: 'wechat',
      wxDialogVisible: false,
      aliDialogVisible: false,
      isSubmitting: false,
      time: null,
      time1: null,
      orderNo: '',
      qrCodeInstance: null,
      pollingInterval: null,
      invoiceInfo: {
        invoiceType: 'personal',
        invoiceTitle: '',
        taxNumber: '',
        invoiceEmail: ''
      },
      invoiceRules: {
        invoiceType: [{required: true, message: '请选择发票类型', trigger: 'change'}],
        invoiceTitle: [
          {required: true, message: '请输入发票抬头', trigger: 'blur'},
          {min: 2, max: 50, message: '长度在 2 到 50 个字符之间', trigger: 'blur'}
        ],
        taxNumber: [
          {required: true, message: '请输入税号', trigger: 'blur'},
          {min: 15, max: 18, message: '税号长度应在 15-18 位之间', trigger: 'blur'}
        ],
        invoiceEmail: [
          {required: true, message: '请输入邮箱', trigger: 'blur'},
          {type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur'},
          {max: 255, message: '邮箱长度不能超过 255 个字符', trigger: 'blur'}
        ]
      }
    }
  },

  computed: {
    selectedSku() {
      if (!this.productDetail || !this.productDetail.skuList) return {}
      return this.productDetail.skuList.find(sku => sku.skuId === this.selectedSkuId) || {}
    }
  },

  created() {
    // 从路由或缓存中获取商品信息
    const productData = this.retrieveOrderConfirmData()
    if (productData) {
      this.productDetail = productData.productDetail
      this.selectedSkuId = productData.selectedSkuId
      this.quantity = productData.quantity
    } else {
      // 如果没有商品数据，返回商品列表页
      this.$message.warning('请先选择商品再提交订单')
      this.$router.push('/shop/productList')
    }
  },

  methods: {
    // 解析规格字符串为对象
    parseSpecs(specsStr) {
      try {
        return JSON.parse(specsStr);
      } catch (e) {
        return {};
      }
    },

    goBack() {
      this.$router.go(-1)
    },

    /**
     * 获取订单确认页所需的商品数据
     * 业务背景：订单确认页刷新会丢失路由参数，需保留用户在商城页选择的商品与数量
     * 设计决策：优先使用路由参数，其次使用 sessionStorage 缓存，确保刷新后仍能恢复上下文
     * @returns {{productDetail:Object, selectedSkuId:string|number, quantity:number} | null} - 若存在则返回订单载荷，否则为 null
     */
    retrieveOrderConfirmData() {
      const routeData = this.$route.params && this.$route.params.productData
      if (routeData) {
        sessionStorage.setItem('orderConfirmProductData', JSON.stringify(routeData))
        return routeData
      }

      const cached = sessionStorage.getItem('orderConfirmProductData')
      if (!cached) {
        return null
      }

      try {
        return JSON.parse(cached)
      } catch (error) {
        console.error('解析订单确认缓存失败', error)
        sessionStorage.removeItem('orderConfirmProductData')
        return null
      }
    },

    /**
     * 处理所在地区的级联选择变化
     * 业务背景：用户必须完整选择省市区才能提交订单，同时需要将编码转换成人类可读的中文名称以便向后端提交
     * 设计决策：将 `orderInfo.areaCodes` 作为级联选择的绑定值用于表单校验，再根据编码查表同步 province/city/area 的中文名
     * @param {string[]} val - 级联选择返回的行政区划编码数组，顺序为 [provinceCode, cityCode, areaCode]
     */
    handleAreaChange(val) {
      this.orderInfo.areaCodes = val || []

      if (val && val.length === 3) {
        // 根据编码查找对应的名称，保证传给后端的是中文可读信息
        const province = provinces.find(p => p.code === val[0])
        const city = cities.find(c => c.code === val[1])
        const area = areas.find(a => a.code === val[2])

        if (province && city && area) {
          this.orderInfo.province = province.name
          this.orderInfo.city = city.name
          this.orderInfo.area = area.name
          return
        }
      }

      // 若选择不完整或未匹配到数据，清空已选名称，避免上传脏数据
      this.orderInfo.province = ''
      this.orderInfo.city = ''
      this.orderInfo.area = ''
    },

    async submitOrder() {
      this.$refs.orderForm.validate(async (valid) => {
        if (!valid) return

        if (!this.selectedSkuId) {
          this.$message.error('请选择商品规格')
          return
        }

        this.isSubmitting = true

        try {
          // 获取实际价格（SKU价格优先，否则使用商品价格）
          const actualPrice = this.selectedSku.price || this.productDetail.price;

          // 构造支付请求参数
          const payRequest = {
            productId: this.productDetail.id,
            skuId: this.selectedSkuId,
            quantity: this.quantity,
            amount: (actualPrice * this.quantity).toString(),
            receiver: this.orderInfo.receiver,
            phone: this.orderInfo.phone,
            province: this.orderInfo.province,
            city: this.orderInfo.city,
            area: this.orderInfo.area,
            detail: this.orderInfo.detail,
            invoiceType: this.invoiceInfo.invoiceType,
            taxNumber: this.invoiceInfo.taxNumber,  // 仅企业发票时有值
            invoiceEmail: this.invoiceInfo.invoiceEmail

          }

          if (this.paymentMethod === 'wechat') {
            // 微信支付
            const result = await request2('post', '/webPay/createCode', payRequest)

            this.wxDialogVisible = true
            this.orderNo = result.outTradeNo

            // 创建二维码
            this.$nextTick(() => {
              // 清除之前的二维码实例
              if (this.qrCodeInstance) {
                this.qrCodeInstance.clear()
                this.qrCodeInstance = null
              }

              // 手动清空 DOM 容器，确保完全清除之前的二维码
              const qrcodeContainer = document.getElementById('qrcode')
              if (qrcodeContainer) {
                qrcodeContainer.innerHTML = ''
              }

              // 创建新的二维码实例
              this.qrCodeInstance = new QRCode('qrcode', {
                width: 280,
                height: 280,
                text: result.code_url
              })
            })

            // 检查支付状态
            this.checkWxPaymentStatus(this.orderNo)
          } else {
            // 支付宝支付
            const res = await request2('post', '/webPay/createQrCode', payRequest)

            const {outTradeNo, form} = res
            this.orderNo = outTradeNo
            this.aliDialogVisible = true

            // 显示支付表单
            this.$nextTick(() => {
              const container = document.getElementById('aliQrcode')
              container.innerHTML = ""

              if (!form) {
                container.innerHTML = "<p>无法生成支付二维码，请联系客服</p>"
                return
              }

              // 使用 iframe 显示表单
              const iframe = document.createElement('iframe')
              iframe.style.border = 'none'
              iframe.style.width = '210px'
              iframe.style.height = '210px'
              iframe.style.margin = '0 auto'
              iframe.style.display = 'block'
              container.appendChild(iframe)

              const iframeDoc = iframe.contentDocument || iframe.contentWindow.document
              iframeDoc.open()
              iframeDoc.write(form)
              iframeDoc.close()
            })

            // 开始轮询支付状态
            this.checkAliPaymentStatus(outTradeNo)
          }
        } catch (error) {
          console.error('创建订单失败:', error)
          const errorMessage = '创建订单失败: ' + (error.message || '未知错误')
          this.$message.error(errorMessage)
          
          // 如果有订单编号，跳转到支付失败页面
          if (this.orderNo) {
            this.goToPaymentFailed(errorMessage)
          }
        } finally {
          this.isSubmitting = false
        }
      })
    },

    /**
     * 检查微信支付状态
     * 业务背景：需要轮询检查支付状态，支付成功后跳转到成功页面
     * 设计决策：使用定时器轮询，支付成功后保存订单信息并跳转，设置最大轮询次数避免无限等待
     */
    checkWxPaymentStatus(orderNo) {
      // 清除之前的轮询
      // if (this.pollingInterval) {
      //   clearInterval(this.pollingInterval)
      // }

      // let pollCount = 0
      // const maxPollCount = 100 // 最大轮询次数（约5分钟）

      // this.pollingInterval = setInterval(() => {
      //   pollCount++
        
      //   // 超过最大轮询次数，停止轮询并提示超时
      //   if (pollCount > maxPollCount) {
      //     clearInterval(this.pollingInterval)
      //     this.pollingInterval = null
      //     this.wxDialogVisible = false
      //     this.$message.error('支付超时，请重新支付')
      //     this.goToPaymentFailed('支付超时，请重新发起支付')
      //     return
      //   }

        request2('get', '/webPay/checkWxPayStatus', { outTradeNo: orderNo }).then(response => {
          if (response === "success") {
            // clearInterval(this.pollingInterval)
            // this.pollingInterval = null
            // this.$message.success('支付成功')
            this.wxDialogVisible = false
            
            // 保存订单信息到 sessionStorage
            const orderAmount = (this.selectedSku.price || this.productDetail.price) * this.quantity
            this.saveOrderInfo(orderNo, orderAmount)
            
            // 跳转到支付成功页面
            this.goToPaymentSuccess(orderNo, orderAmount)
          } else if (response === "failed" || response === "error") {
            // 支付失败
            // clearInterval(this.pollingInterval)
            // this.pollingInterval = null
            this.wxDialogVisible = false
            this.$message.error('支付失败')
            this.goToPaymentFailed('支付失败，请重试')
          }
        }).catch(error => {
          // 请求失败，但不立即停止轮询，可能是网络问题
          console.error('检查支付状态失败:', error)
        })
      // }, 3000)
    },

    /**
     * 检查支付宝支付状态
     * 业务背景：需要轮询检查支付状态，支付成功后跳转到成功页面
     * 设计决策：使用定时器轮询，支付成功后保存订单信息并跳转，设置最大轮询次数避免无限等待
     */
    checkAliPaymentStatus(orderNo) {
      // 清除之前的轮询
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval)
      }

      let pollCount = 0
      const maxPollCount = 100 // 最大轮询次数（约5分钟）

      this.pollingInterval = setInterval(() => {
        pollCount++
        
        // 超过最大轮询次数，停止轮询并提示超时
        if (pollCount > maxPollCount) {
          clearInterval(this.pollingInterval)
          this.pollingInterval = null
          this.aliDialogVisible = false
          this.$message.error('支付超时，请重新支付')
          this.goToPaymentFailed('支付超时，请重新发起支付')
          return
        }

        request2('get', '/webPay/checkAliPayStatus', { outTradeNo: orderNo }).then(response => {
          if (response === "success") {
            clearInterval(this.pollingInterval)
            this.pollingInterval = null
            this.$message.success('支付成功')
            this.aliDialogVisible = false
            
            // 保存订单信息到 sessionStorage
            const orderAmount = (this.selectedSku.price || this.productDetail.price) * this.quantity
            this.saveOrderInfo(orderNo, orderAmount)
            
            // 跳转到支付成功页面
            this.goToPaymentSuccess(orderNo, orderAmount)
          } else if (response === "failed" || response === "error") {
            // 支付失败
            clearInterval(this.pollingInterval)
            this.pollingInterval = null
            this.aliDialogVisible = false
            this.$message.error('支付失败')
            this.goToPaymentFailed('支付失败，请重试')
          }
        }).catch(error => {
          // 请求失败，但不立即停止轮询，可能是网络问题
          console.error('检查支付状态失败:', error)
        })
      }, 3000)
    },

    /**
     * 取消订单并清理相关资源
     * 业务背景：用户关闭支付弹窗时需要清理二维码、定时器等资源，避免内存泄漏和重复显示
     * 设计决策：统一清理所有相关资源，包括二维码实例、DOM 元素、轮询定时器等
     */
    cancelOrder() {
      // 清理定时器
      if (this.time1) {
        clearInterval(this.time1)
        this.time1 = null
      }
      if (this.time) {
        clearInterval(this.time)
        this.time = null
      }
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval)
        this.pollingInterval = null
      }

      // 清除微信支付二维码实例和 DOM
      if (this.qrCodeInstance) {
        this.qrCodeInstance.clear()
        this.qrCodeInstance = null
      }
      const qrcodeContainer = document.getElementById('qrcode')
      if (qrcodeContainer) {
        qrcodeContainer.innerHTML = ''
      }

      // 清除支付宝支付容器
      const aliQrcodeContainer = document.getElementById('aliQrcode')
      if (aliQrcodeContainer) {
        aliQrcodeContainer.innerHTML = ''
      }

      // 清除提示文本
      const closeTextElement = document.getElementById("closeText")
      if (closeTextElement) {
        closeTextElement.innerHTML = ""
      }

      // 关闭弹窗
      this.wxDialogVisible = false
      this.aliDialogVisible = false
    },

    /**
     * 保存订单信息到 sessionStorage
     * 业务背景：支付成功后需要保存订单信息，以便在支付成功页面展示
     * 设计决策：使用 sessionStorage 存储订单信息，刷新页面后仍可访问
     * @param {string} orderNo - 订单编号
     * @param {number|string} orderAmount - 订单金额
     */
    saveOrderInfo(orderNo, orderAmount) {
      const orderInfo = {
        orderNo: orderNo,
        orderAmount: orderAmount.toString()
      };
      sessionStorage.setItem('lastOrderInfo', JSON.stringify(orderInfo));
    },

    /**
     * 跳转到支付成功页面
     * 业务背景：支付成功后需要跳转到专门的反馈页面，展示订单信息
     * 设计决策：通过路由参数传递订单信息，确保信息准确传递
     * @param {string} orderNo - 订单编号
     * @param {number|string} orderAmount - 订单金额
     */
    goToPaymentSuccess(orderNo, orderAmount) {
      this.$router.push({
        name: 'PaymentSuccess',
        params: {
          orderNo: orderNo,
          orderAmount: orderAmount.toString()
        }
      });
    },

    /**
     * 跳转到支付失败页面
     * 业务背景：支付失败时需要跳转到专门的反馈页面，告知用户失败原因
     * 设计决策：通过路由参数传递订单编号和错误信息，帮助用户了解失败原因
     * @param {string} errorMessage - 错误信息
     */
    goToPaymentFailed(errorMessage) {
      this.$router.push({
        name: 'PaymentFailed',
        params: {
          orderNo: this.orderNo || '',
          errorMessage: errorMessage || '支付失败，请重试'
        }
      });
    }
  },

  beforeDestroy() {
    // 组件销毁前清理所有资源
    if (this.time1) {
      clearInterval(this.time1)
    }
    if (this.time) {
      clearInterval(this.time)
    }
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval)
    }
    // 清除二维码实例和 DOM
    if (this.qrCodeInstance) {
      this.qrCodeInstance.clear()
      this.qrCodeInstance = null
    }
    const qrcodeContainer = document.getElementById('qrcode')
    if (qrcodeContainer) {
      qrcodeContainer.innerHTML = ''
    }
    const aliQrcodeContainer = document.getElementById('aliQrcode')
    if (aliQrcodeContainer) {
      aliQrcodeContainer.innerHTML = ''
    }
  }
}
</script>

<style scoped>
.order-confirm-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  text-align: left;
}

.order-confirm-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.back-button {
  margin-right: 15px;
  padding: 8px 16px;
  background: #f5f7fa;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #666;
  cursor: pointer;
  font-size: 14px;
}

.section {
  background: #fff;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.section h3 {
  margin: 0 0 15px 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  color: #333;
}

.product-summary {
  display: flex;
  margin-bottom: 15px;
}

.product-image {
  width: 150px;
  height: 150px;
  min-height: 150px;
  margin-right: 20px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
  display: block;
}

.product-details {
  flex: 1;
}

.product-details h4 {
  margin: 0 0 10px 0;
  font-size: 18px;
  color: #333;
}

.product-specs-container {
  margin-bottom: 15px;
}

.specs-title {
  font-weight: bold;
  color: #666;
  margin-bottom: 5px;
}

.specs-content {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.spec-item {
  display: inline-flex;
  background-color: #f0f2f5;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 14px;
}

.spec-key {
  font-weight: 500;
  color: #606266;
  margin-right: 4px;
}

.spec-value {
  color: #333;
}

.price-quantity {
  display: flex;
  justify-content: space-between;
}

.price {
  color: #ff7452;
  font-weight: bold;
  font-size: 18px;
}

.total-amount {
  text-align: right;
  font-size: 18px;
  color: #333;
}

.amount {
  color: #ff7452;
  font-weight: bold;
  font-size: 20px;
}

.payment-methods {
  padding: 10px 0;
}

.payment-options {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.payment-option {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 15px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
}

.payment-option:hover {
  border-color: #409eff;
}

.payment-option.active {
  border-color: #409eff;
  background-color: #ecf5ff;
}

.payment-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}


.payment-svg {
  font-size: 24px;
}

.alipay-logo {
  font-size: 20px;
  font-weight: bold;
}

.payment-name {
  font-size: 16px;
  color: #333;
}

.total-price {
  color: #ff7452;
  font-size: 24px;
  font-weight: bold;
}

/* 二维码容器样式 - 确保二维码在父容器中居中显示 */
.qrcode-container {
  width: 300px;
  height: 300px;
  margin: 20px auto;
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

/* 确保 QRCode 库生成的 canvas 或 img 元素在容器内居中 */
.qrcode-container canvas,
.qrcode-container img {
  display: block;
  margin: 0 auto;
}

/* 确保支付宝 iframe 在容器内居中 */
.qrcode-container iframe {
  display: block;
  margin: 0 auto;
  border: none;
}

/* 移动端响应式样式 */
@media (max-width: 768px) {
  .order-confirm-container {
    padding: 10px;
  }

  .order-confirm-header {
    padding: 10px;
    margin-bottom: 15px;
  }

  .order-confirm-header h2 {
    font-size: 20px;
  }

  .order-content {
    flex-direction: column !important;
    gap: 15px !important;
  }

  .section {
    padding: 15px;
    margin-bottom: 15px;
  }

  .section h3 {
    font-size: 16px;
    margin-bottom: 12px;
  }

  .product-summary {
    flex-direction: column;
  }

  .product-image {
    width: 100%;
    height: 250px;
    min-height: 250px;
    margin-right: 0;
    margin-bottom: 15px;
    overflow: hidden;
  }

  .product-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .product-details h4 {
    font-size: 16px;
  }

  .price-quantity {
    flex-direction: column;
    gap: 10px;
  }

  .price {
    font-size: 16px;
  }

  .total-amount {
    text-align: left;
    font-size: 16px;
  }

  .amount {
    font-size: 18px;
  }

  /* 移动端表单样式优化 */
  .el-form-item {
    margin-bottom: 15px;
  }

  .el-form-item__label {
    font-size: 14px;
    padding-bottom: 5px;
  }

  .el-input__inner,
  .el-cascader__input {
    font-size: 14px;
  }

  /* 移动端支付方式选择 */
  .payment-option {
    padding: 12px;
    margin-bottom: 10px;
  }

  .payment-icon {
    width: 30px;
    height: 30px;
  }

  .payment-name {
    font-size: 14px;
  }

  /* 移动端提交按钮 */
  .submit-button {
    width: 100%;
    padding: 14px;
    font-size: 16px;
    margin-top: 20px;
  }

  /* 移动端二维码容器 */
  .qrcode-container {
    width: 100%;
    max-width: 280px;
    height: 280px;
    margin: 15px auto;
    padding: 10px;
  }

  /* 移动端对话框样式 */
  .el-dialog {
    width: 90% !important;
    margin: 5vh auto !important;
  }

  .el-dialog__body {
    padding: 15px;
  }
}

/* 提交订单按钮样式 - 使用主题色 */
.order-confirm-container .el-button--primary {
  background-color: #7b9d38;
  border-color: #7b9d38;
  color: #fff;
}

.order-confirm-container .el-button--primary:hover,
.order-confirm-container .el-button--primary:focus {
  background-color: #6a8a2f;
  border-color: #6a8a2f;
  color: #fff;
}

.order-confirm-container .el-button--primary:active {
  background-color: #5a7a1f;
  border-color: #5a7a1f;
  color: #fff;
}

.order-confirm-container .el-button--primary.is-loading {
  background-color: #7b9d38;
  border-color: #7b9d38;
}

.order-confirm-container .el-button--primary.is-disabled {
  background-color: #c0c4cc;
  border-color: #c0c4cc;
  color: #fff;
}

</style>
